import { h } from 'preact';
import { useEffect } from 'preact/hooks';

import Router, { route } from 'preact-router';
import { useCallback } from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { memo } from 'preact/compat';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import { PUBLIC_FOLDER } from '../../consts.js';

import FrontEndLazyLoader from '../frontendLazyLoader/frontendLazyLoader.jsx';

import { actions as navigationActions } from '../../store/state/navigation.js';
import { actions as drawerActions } from '../../store/state/drawer.js';

import EditEndpoint from '../../routes/editV1Endpoint/index.jsx';
import LazyEditEndpoint from '../../routes/editV1Endpoint/lazy.jsx';

import NewEndpoint from '../../routes/newV1Endpoint/index.jsx';
import LazyNewEndpoint from '../../routes/newV1Endpoint/lazy.jsx';

import NewV2Endpoint from '../../routes/newV2Endpoint/index.jsx';
import LazyNewV2Endpoint from '../../routes/newV2Endpoint/lazy.jsx';

import EditV2Endpoint from '../../routes/editV2Endpoint/index.jsx';
import LazyEditV2Endpoint from '../../routes/editV2Endpoint/lazy.jsx';

import ChangeV2Endpoint from '../../routes/changeV2Endpoint/index.jsx';
import LazyChangeV2Endpoint from '../../routes/changeV2Endpoint/lazy.jsx';

function Root() {
  function redirect() {
    route(`${PUBLIC_FOLDER}/v2`, true);
  }

  useEffect(redirect, []);

  return <LazyNewV2Endpoint />;
}

function Main(_props) {
  const dispatch = useDispatch();

  const onRouteChange = useCallback(
    function onRouteChange(routeInfo) {
      const [active] = routeInfo.active;
      if (!active) {
        dispatch(navigationActions.CLEAR_PARAMS());
        return;
      }

      const { endpointId } = active.props;

      const action = navigationActions.NEW_PARAMS({
        endpointId,
      });

      dispatch(action);

      dispatch(drawerActions.CLOSE());
    },
    [dispatch]
  );

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: theme => theme.palette.grey[100],
        flexGrow: 1,
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Toolbar />
      <Router onChange={onRouteChange}>
        <FrontEndLazyLoader
          path={`${PUBLIC_FOLDER}/v2/change/:endpointId/:changeId`}
          LL_Component={ChangeV2Endpoint}
          LL_Fallback={LazyChangeV2Endpoint}
        />

        <FrontEndLazyLoader
          path={`${PUBLIC_FOLDER}/v2/edit/:endpointId`}
          LL_Component={EditV2Endpoint}
          LL_Fallback={LazyEditV2Endpoint}
        />

        <FrontEndLazyLoader
          path={`${PUBLIC_FOLDER}/v2`}
          LL_Component={NewV2Endpoint}
          LL_Fallback={LazyNewV2Endpoint}
        />

        <FrontEndLazyLoader
          path={`${PUBLIC_FOLDER}/v1/edit/:endpointId`}
          LL_Component={EditEndpoint}
          LL_Fallback={LazyEditEndpoint}
        />

        <FrontEndLazyLoader
          path={`${PUBLIC_FOLDER}/v1`}
          LL_Component={NewEndpoint}
          LL_Fallback={LazyNewEndpoint}
        />

        <Root path={`${PUBLIC_FOLDER}/`} />
      </Router>
    </Box>
  );
}

export default memo(Main);
